import React from "react"

export default function Input(props) {
  return (
    <div className="input-field">
      <input
        value={props.value}
        onChange={(e) => props.SetValue(props.field, e.target.value)}
        placeholder={props.placeholder}
        id={props.id}
        type={props.type}
        title={props.value}
      />
      <label htmlFor={props.id}>{props.caption}</label>
    </div>
  )
}
